/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import moment from 'moment';
import { defineMessages } from 'react-intl';
import MeetingRoom from './MeetingRoom';
import ReservationDialog from '../commons/ReservationDialog';
import PromptInfo from '../../utils/promptInfo';
import DayTimeTable from './DayTimeTable';
import PropTypes from 'prop-types';

const DialogType = PromptInfo.DialogType;

const messages = defineMessages({
  end: {
    id: 'search_page_end'
  }
});

class DayView extends React.Component {
  _timeMap = new Map();

  constructor(props) {
    super(props);
    this._length = 48;
    this._interval = 30;
    this.makeTimeTitle = this.makeTimeTitle.bind(this);
    this.makeMeetingRoom = this.makeMeetingRoom.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePrevPage = this.handlePrevPage.bind(this);
    this.handleScrollLeftOnMouseDown = this.handleScrollLeftOnMouseDown.bind(
      this
    );
    this.handleScrollRightOnMouseDown = this.handleScrollRightOnMouseDown.bind(
      this
    );
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleScrollLeft = this.handleScrollLeft.bind(this);
    this.handleScrollRight = this.handleScrollRight.bind(this);
    this.state = {
      dayLeft: 0
    };
  }

  getTitleHour = (time) => {
    if(time.hours() > 0 || time.minutes() > 0){
      if(window.screen.width <= 1440){
        if(time.minutes() === 0){
          return time.format('HH:mm');
        }
      } else {
        return time.format('HH:mm');
      }
    }
    return "";
  };

  makeTimeTitle() {
    const { showTime } = this.props;
    const begin = moment(showTime);
    let titleDiv = new Array(this._length);
    for (let i = 0; i < this._length; i++) {
      if (i > 0) {
        begin.add(this._interval, 'minutes');
      }
      this._timeMap.set(i, moment(begin));
      titleDiv.push(
        <li
          key={i}
          style={{ width: `${window._liWidth/2}px` }}
          className="time-title-li"
        >
          <span className="time-title-span">
            {this.getTitleHour(begin)}
          </span>
        </li>
      );
    }
    return titleDiv;
  }

  makeMeetingRoom() {
    const { searchResults, intl, dispatch,meetingPolicy } = this.props;
    let roomDiv = new Array(searchResults.list.size);
    let timeTable = new Array(searchResults.list.size);
    searchResults.list.map((v, i) => {
      roomDiv.push(
        <MeetingRoom
          meetingPolicy={meetingPolicy}
          from={'DayView'}
          room={v}
          key={v.id}
          intl={intl}
          dispatch={dispatch}
        />
      );
      timeTable.push(
        <DayTimeTable
          {...this.props}
          index={i}
          room={v}
          days={this._length}
          timeMap={this._timeMap}
          liWidth={window._liWidth}
          key={v.id}
        />
      );
    });
    return { roomDiv, timeTable };
  }

  handleNextPage() {
    const { dispatch, searchResults, timeType } = this.props;
    if (searchResults.pageNo < searchResults.pageCount) {
      dispatch({
        type: 'meeting/getCalenderData',
        filter: {
          type: timeType,
          pageNo: searchResults.pageNo + 1,
          locale: this.props.intl.formatMessage({ id: 'locale' })
        }
      });
    } else {
      this.scrollEnd();
    }
  }

  handlePrevPage() {
    const { dispatch, searchResults, timeType } = this.props;
    if (searchResults.pageNo > 1) {
      dispatch({
        type: 'meeting/getCalenderData',
        filter: {
          type: timeType,
          pageNo: searchResults.pageNo - 1,
          locale: this.props.intl.formatMessage({ id: 'locale' })
        }
      });
    } else {
      this.scrollEnd();
    }
  }

  scrollEnd() {
    const { intl, locale } = this.props;
    ReservationDialog({
      type: DialogType.INFORMATION,
      message: intl.formatMessage(messages.end),
      locale: locale
    });
  }

  handleScrollLeftOnMouseDown() {
    this._timer = setInterval(this.handleScrollLeft, 100);
  }

  handleScrollRightOnMouseDown() {
    this._timer = setInterval(this.handleScrollRight, 100);
  }

  handleMouseUp() {
    clearInterval(this._timer);
  }

  handleScrollLeft() {
    this._right.scrollLeft = this._right.scrollLeft - window._liWidth;
  }

  handleScrollRight() {
    this._right.scrollLeft = this._right.scrollLeft + window._liWidth;
  }

  componentDidMount() {
    this.scrollToNow();
  }

  render() {
    const { searchResults } = this.props;
    const { roomDiv, timeTable } = this.makeMeetingRoom();
    return (
      <div className="day-title">
        <i
          className="iconfont icon-arrow-left"
          onClick={this.handleScrollLeft}
          onMouseDown={this.handleScrollLeftOnMouseDown}
          onMouseUp={this.handleMouseUp}
          onMouseOut={this.handleMouseUp}
        />
        <i
          className="iconfont icon-arrow-right"
          onClick={this.handleScrollRight}
          onMouseDown={this.handleScrollRightOnMouseDown}
          onMouseUp={this.handleMouseUp}
          onMouseOut={this.handleMouseUp}
        />
        <div className="table">
          <div
            className="table-left table-height-day"
            ref={c => (this._left = c)}
          >
            {searchResults.pageNo > 1 && (
              <div className="table-up">
                <i className="iconfont icon-up" onClick={this.handlePrevPage} />
              </div>
            )}
            <div className="empty" />
            <div className="roomDiv">{roomDiv}</div>
            {searchResults.pageNo < searchResults.pageCount && (
              <div className="table-down">
                <i
                  className="iconfont icon-down"
                  onClick={this.handleNextPage}
                />
              </div>
            )}
          </div>
          <div
            className="table-right table-right-day-view table-height-day"
            ref={c => (this._right = c)}
          >
            <div
              className="day-content"
              style={{ width: `${window._liWidth * 24}px` }}
            >
              <ul className="table-right-div ul1">{this.makeTimeTitle()}</ul>
              {timeTable}
            </div>
          </div>
        </div>
      </div>
    );
  }

  scrollToNow = () => {
    let scrollFlag = false;
    let $this = this;
    let timer = window.setInterval(() => {
      const target = document.getElementById("current-hour-li");
      if(!scrollFlag && $this._right && target){
        $this._right.scrollLeft = target.offsetLeft;
        window.clearInterval(timer);
        scrollFlag = true;
      }
    }, 100);
    window.setTimeout(() => {//未免出现定时器无限调用，这里加个保险措施，5秒后清除定时器
      if(timer){
        window.clearInterval(timer);
      }
    }, 5000);
  }
}

DayView.propTypes = {
  searchResults: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired
};

DayView.defaultProps = {
  timeType: 1
};

export default DayView;



// WEBPACK FOOTER //
// ./src/components/meeting/DayView.js